module.exports = __webpack_public_path__ + "img/Tablet - 36.fd7d2c52.png";